import { useEffect } from "react";
import { X } from "lucide-react";

export default function ImagePreviewModal({ image, onClose }) {
  useEffect(() => {
    if (!image) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [image, onClose]);

  if (!image?.src) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/85 p-3 backdrop-blur-sm sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={image.name || "Image preview"}
      onClick={onClose}
    >
      <div className="relative flex max-h-full w-full max-w-5xl items-center justify-center" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          onClick={onClose}
          className="absolute right-2 top-2 z-10 grid h-10 w-10 place-items-center rounded-full border border-white/15 bg-black/70 text-white shadow-lg hover:bg-white/10"
          aria-label="Close image preview"
        >
          <X className="h-5 w-5" />
        </button>
        <img
          src={image.src}
          alt={image.name || "Attachment"}
          className="max-h-[88dvh] max-w-full rounded-2xl border border-white/10 bg-black object-contain shadow-2xl"
        />
      </div>
    </div>
  );
}
